import React from 'react';
import styles from '../VideoAnalyzer.module.css';

const FullscreenControls = ({
    recordingTime,
    timeLimit,
    isRecording,
    processingState,
    onStopRecording,
    onSaveRecording
}) => {
    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <div className={styles.fullscreenControls}>
            <div className={styles.timer}>
                {formatTime(recordingTime)} / {formatTime(timeLimit)}
            </div>
            <button
                className={`${styles.controlButton} ${isRecording ? styles.recording : ''} ${processingState === 'stopped' ? styles.readyToSave : ''
                    }`}
                onClick={isRecording ? onStopRecording : onSaveRecording}
            >
                {isRecording ? 'Stop Recording' : 'Save Recording'}
            </button>
        </div>
    );
};

export default FullscreenControls;